import React from 'react'

import { Box } from '@mui/material'

type CodeProps = {
  children?: React.ReactNode
}

const Code = ({ children }: CodeProps) => (
  <Box sx={{ mt: 4 }}>
    <Box
      component="code"
      sx={{
        display: 'block',
        my: 2,
        p: 2,
        border: '1px solid',
        borderColor: 'grey.300',
        borderRadius: 1,
        bgcolor: 'grey.50',
        color: 'text.secondary',
        whiteSpace: 'pre-line',
        wordWrap: 'break-word',
      }}>
      {children}
    </Box>
  </Box>
)

export default Code
